import React from 'react';

export const PRODUCT_TYPE_HEADER = '제품 유형 / Product Type';
export const PRODUCT_TYPE_TOOLTIP = 'VeriPass가 분류한 제품 카테고리 / Product category classified by VeriPass';
export const RISK_TOOLTIP = '규제 위반 가능성 수준 / Regulatory non-compliance risk level';

export function HeaderWithTooltip({ label, tooltip }) {
  return (
    <span className="rp-th-with-help">
      <span>{label}</span>
      <span
        className="rp-info-icon"
        tabIndex={0}
        title={tooltip}
        aria-label={tooltip}
        role="img"
      >
        ?
      </span>
    </span>
  );
}

export default function ReportTableHeader() {
  return (
    <thead>
      <tr>
        <th>Date</th>
        <th>Title</th>
        <th className="rp-col-product-type">
          <HeaderWithTooltip label={PRODUCT_TYPE_HEADER} tooltip={PRODUCT_TYPE_TOOLTIP} />
        </th>
        <th className="rp-col-risk">
          <HeaderWithTooltip label="Risk" tooltip={RISK_TOOLTIP} />
        </th>
        <th>Actions</th>
      </tr>
    </thead>
  );
}
